import Drawer from "@/components/Drawer"
import Layout from "@/components/Layout"
import MissionList from "@/components/MissionList"
import { withAuthentication } from "@/lib/withAuthentication"
import * as missions from "@/store/missions/asyncActions"
import { Mission, MissionLoadingStatus } from "@/store/missions/models"
import { AppState } from "@/store/reducers"
import { NextPage } from "next"
import Head from "next/head"
import qs from "querystring"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"

interface PageProps {
  missionLoadingStatus: MissionLoadingStatus
  getAllMissions: () => Promise<void>
  missions: Mission[] | null
  query: any
}

const sortMissionsByDate = (a: Mission, b: Mission) => {
  return (b.startDate as Date).getTime() - (a.startDate as Date).getTime()
}

const Missions: NextPage<PageProps> = (props) => {
  const [hasLoaded, setHasLoaded] = useState<boolean>()
  const [initialMission, setInitialMission] = useState<Mission>()

  useEffect(() => {
    props.getAllMissions()
  }, [])

  useEffect(() => {
    if (!props.missions) {
      return
    }
    const initialMissionId = qs.parse(window.location.search.substring(1))
      .initialMission

    if (initialMissionId) {
      setInitialMission(
        props.missions.find((i) => i.missionUuid === initialMissionId)
      )
    }

    setHasLoaded(true)
  }, [props.missions])

  return (
    <>
      <Head>
        <title>Black Mirror - Missions</title>
        <meta name="description" content="meta" />
      </Head>

      <Layout>
        <Drawer title="Missions">
          {hasLoaded && (
            <MissionList
              missions={props.missions}
              initialMission={initialMission}
            />
          )}
        </Drawer>
      </Layout>
    </>
  )
}

Missions.getInitialProps = async ({
  reduxStore,
  query
}: any): Promise<PageProps> => {
  return query || {}
}

export default withAuthentication(
  connect(
    (state: AppState) => ({
      missions:
        state.missions.allMissions &&
        state.missions.allMissions.sort(sortMissionsByDate),
      missionLoadingStatus: state.missions.allMissionsLoadingStatus
    }),
    (dispatch: any) => ({
      getAllMissions: () => dispatch(missions.getAllMissions()) as Promise<void>
    })
  )(Missions)
)
